export const ALPHA_OPACITY = {
  DISABLED: 0.32,
  DISABLED_LABEL: 0.8,
} as const;
